module.exports = __webpack_public_path__ + "static/media/4 1 tattoo forearm ent dragon knight helmet fantasy mythical.1280x1654.0917738d.webp";